// Grid hover-play: swaps a muted sampled <video> (with the shared player
// chrome) into the active cell while the preview panel is closed. Wired to no
// pointer events of its own — armHover/cancelHoverPlay are driven by
// preview.js's active cell via app.js's onCurrent hook (see armHover below).
import { settings } from './settings.js';
import { mountVideoPreview } from './video.js';

let hoverTimer = null, hoverCell = null;

function stopHoverPlay(cell) {
  if (!cell?._hoverPlaying) return;
  cell._hoverPlaying = false;
  cell._hoverCleanup?.(); cell._hoverCleanup = null;
  cell._hoverVideo?.remove(); cell._hoverVideo = null;
}

export function cancelHoverPlay() {
  clearTimeout(hoverTimer); hoverTimer = null;
  const cell = hoverCell; hoverCell = null;
  stopHoverPlay(cell);
}

async function startHoverPlay(cell) {
  const v = document.createElement('video');
  v.muted = true; v.playsInline = true;
  const teardown = await mountVideoPreview(cell, v, cell._item, {
    stillWanted: () => cell === hoverCell
  });
  if (!teardown) return;
  cell.appendChild(v);
  cell._hoverVideo = v; cell._hoverPlaying = true;
  cell._hoverCleanup = teardown;
}

// Arm grid hover-play for `cell` (after the hover delay), or cancel when it's
// null / not a video. Driven by preview.js's active cell (curCell) via app.js's
// onCurrent hook, so mouse hover, keyboard nav and touch tap all play the
// focused video uniformly — only while preview is off (the panel plays it
// otherwise). Idempotent on the same cell.
export function armHover(cell) {
  if (cell === hoverCell) return;
  cancelHoverPlay();
  if (!cell || cell._item.kind !== 'video') return;
  hoverCell = cell;
  hoverTimer = setTimeout(() => startHoverPlay(cell), settings.get('hoverDelay'));
}

export function initHoverPlay() {
  // Turning the preview panel on hands video playback to the panel — stop any
  // grid hover-play still running. (Turning it off re-arms via app.js onCurrent.)
  settings.onChange('preview', (on) => { if (on) cancelHoverPlay(); });
}
